import { deleteInsight as deleteInsightCall } from '../../services/polaris-api/delete-insight/index.tsx';
import type { DeleteInsightRequest, ProviderProps, RemoteInsightDeleter } from '../../types.tsx';

export const deleteInsight =
	({ apolloClient }: Omit<ProviderProps, 'projectId'>): RemoteInsightDeleter =>
	({ id }: DeleteInsightRequest) =>
		deleteInsightCall(apolloClient, id);
